export default "__VITE_ASSET__4c701aa4__"